module.exports = __webpack_public_path__ + "twitter.svg?c9f1200836515fd4bacd29160be78732";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social/twitter.svg
// module id = 36
// module chunks = 0